import moment from "moment";

export default {

  namespaced: true,

  state: () => ({
    user: null
  }),

  mutations: {
    setUser(state, user) {
      state.user = user
    }
  },

  getters: {
    isLoggedIn: state => {
      return (state.user !== null)
    },
    
    isSubscriptionExpired: (state, getters) => {
      return moment(state.user.company.last_subscription.block_access_at).diff(
        moment().startOf("day"),
        "days"
      ) < 0;
    },
  },

  actions: {
    
    login({ commit, state}, params) {
      return new Promise ((resolve, reject) => {
        axios
          .post("api/login", params)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          });
      })
    },

    async loggout({ commit, state }) {
      commit('setUser', null)
    },

    async loadUser({ commit, state }) {
      await axios.post(process.env.BASE_URL + 'api/selectloggeduser')
        .then(response => {

          commit('setUser', response.data)
          commit('userHasLoaded', { data: response.data }, { root: true })
          commit('events/userHasLoggedIn', {
            userId: response.data.user.id,
            userEmail: response.data.user.email,
            companyName: response.data.company.name,
          }, { root: true })

        }).catch(error => {
          commit('setUser', null)
          commit("userHasLoadedWithError", { error: error }, { root: true });
        });
    }
  }
}